import {
  ForecastChartData,
  ForecastChartDataKeys,
} from "../services/financial-forecast";
import { lineStyles } from "./chart-style";

export const getLabels = (data: ForecastChartData) => {
  if (Object.values(data).some((item) => item == null)) return [];

  // Get all labels from data, and remove duplicates by using Set
  const labelsSet = new Set(
    Object.values(data)
      .flat()
      .map((item) => item?.date ?? "")
  );

  return Array.from(labelsSet).sort();
};

export const getDatasets = (labels: string[], data: ForecastChartData) => {
  if (labels.length === 0) return [];

  return Object.entries(data)
    .map(([key, value]) => ({
      label: key,
      data: labels.map(
        (label) => value?.find((item) => item.date === label)?.value
      ),
      ...lineStyles[key as ForecastChartDataKeys],
    }))
    .sort((a, b) => {
      const orders = ["pastData", "maxForecast", "avgForecast", "minForecast"];
      return orders.indexOf(a.label) - orders.indexOf(b.label);
    });
};
